import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import SettingsPanel from "./settingsPanel";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services/common.service";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// import Table from "components/Table/Table.jsx";
import { connect } from "react-redux";
import Tabs from "components/CustomTabs/CustomTabs.jsx";
import Seat from "@material-ui/icons/AirlineSeatFlat";
import Airline from "@material-ui/icons/AirlineSeatReclineNormal";
import ApprovedTable from "./approvedTable";
import AllPscTable from "./allCharges";
import { appConstants } from "../../_constants";
import CircularProgress from "../../utils/CircularProgress";
import { Grid, TextField, FormControl } from "@material-ui/core";
import InlineDatePicker from "../../utils/InlineDatePicker";
import { appHelpers } from "../../_helpers";

const styles = (theme) => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  negativeColor: {
    color: "red",
  },
  positiveColor: {
    color: "green",
  },
  nb: {
    color: "red",
    fontSize: "12px",
  },
  wide: {
    width: "100%",
    minWidth: "300px",
  },
});

class PscSettingsTable extends React.Component {
  state = {
    page: 0,
    response: "",
    rowsPerPage: 10,
    open: false,
    openApprove: false,
    airlineName: "",
    airlineId: "",
    PscChargePendingId: "",
    pendingRecord: "",
    recordCreatedBy: "",
    newRecordCharge: "",
    oldRecordCharge: "",
    ApprovedBy: "",
    pscData: [],
    pendingPscData: [],
    openModal: false,
    currentPsc: "",
    startDateNew:new Date(),
    startDateEdit:new Date(),
    errorMessage: "",
    errorComponent: false,
    editErrorComponent: false,
    users: [],
    PageCount: 10,
    currentPage: 1,
    currentPagePending: 1,
    TotalCount: 0,
    totalCountPending: 0,
    error: false,
    formError: "",
    requestingFlights: true,
    reason: "",
    comment: "",
    Status: "",
    openComment: false,
    pscPendingId: "",
  };

  componentDidMount() {
    let { users, dispatch } = this.props;
    if (users) {
      this.setState({ users: users.ResultList });
    } else {
      dispatch(commonActions.getAllUsers());
    }
    this.getAllPsc();
    this.getAllUnprocessedPendingPsc();
    this.getCurrentPsc();
  }

  componentWillReceiveProps = function(nextProps) {
    const { airlines, users } = nextProps;
    if (airlines) {
      this.setState({ airlinesData: airlines.Results });
    }
    if (users) {
      this.setState({ users: users.ResultList });
    }
  };

  //Get currrent Psc
  getCurrentPsc = () => {
    const { dispatch } = this.props;
    commonService
      .getCurrentPsc()
      .then((getPsc) => {
        if (getPsc.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({ currentPsc: getPsc.response.PscCharge });
        } else if (getPsc.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(getPsc.response));
          this.setState({ pageRequesting: false });
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.response));
      });
    dispatch(alertActions.clear());
  };

  //Get All PSC Charge
  getAllPsc = (pageNumber) => {
    const { dispatch } = this.props;
    const { PageCount } = this.state;
    let fromIndex;
    if (pageNumber === undefined) {
      fromIndex = 1;
      pageNumber = 1;
    } else {
      fromIndex = pageNumber;
    }
    dispatch(alertActions.startRequest());
    commonService
      .getAllPsc(fromIndex, PageCount)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({
            pageRequesting: false,
            currentPage: pageNumber,
            pscData: res.response.PendingPscCharge,
            TotalCount: res.response.TotalCount,
          });
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.response));
      });
    dispatch(alertActions.clear());
  };

  //Get All PSC Charge
  getAllUnprocessedPendingPsc = (pageNumber) => {
    const { dispatch } = this.props;
    const { PageCount } = this.state;
    let fromIndex;
    if (pageNumber === undefined) {
      fromIndex = 1;
      pageNumber = 1;
    } else {
      fromIndex = pageNumber;
    }
    dispatch(alertActions.startRequest());
    commonService
      .getAllUnprocessedPendingPsc(fromIndex, PageCount)
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          dispatch(alertActions.stopRequest());
          this.setState({
            pageRequesting: false,
            currentPagePending: pageNumber,
            pendingPscData: res.response.PendingPscCharge,
            totalCountPending: res.response.TotalCount,
          });
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ pageRequesting: false });
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.response));
      });
    dispatch(alertActions.clear());
  };

  //Save new PSC value Button
  handlePscSave = () => {
    const { pscChargesNew, currentPsc, startDateNew } = this.state;
    const { user, dispatch } = this.props;
    let payload = {
      OldCharges: currentPsc,
      NewCharges: pscChargesNew,
      CreatedBy: user.userId,
      StartDate: appHelpers.formatDateSpecific(startDateNew, "YYYY-MM-DD"),
    };
    console.log("azee",payload)
    dispatch(alertActions.startRequest());
    commonService
      .savePsc(payload)
      .then((res) => {
        if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ formError: res.response, error: true });
        } else if (res.status === appConstants.SUCCESS_RESPONSE) {
          dispatch(alertActions.stopRequest());
          dispatch(alertActions.notify("Saved Successfully"));
          this.getAllPsc();
          this.getAllUnprocessedPendingPsc();
          this.getCurrentPsc();
          this.setState({ openModal: false, editErrorComponent: false });
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.response));
      });
    dispatch(alertActions.clear());
  };

  //Handle Input
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleDateChange = (date, target) => {
    this.setState({ [target]: date });
  };

  //Open Set New PSC Modal
  handlePsc = () => {
    this.setState({ openModal: true });
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      openApprove: false,
      open: false,
      openComment: false,
    });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleSelectChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };
  handleEdit = (item) => {
    const { Id, OldCharges, NewCharges, CreatedBy, StartDate } = item;
    this.setState({
      open: true,
      pendingRecord: Id,
      oldRecordCharge: OldCharges,
      newRecordCharge: NewCharges,
      recordCreatedBy: CreatedBy,
      startDateEdit: StartDate,
    });
  };

  handleEditPsc = () => {
    const {
      pendingRecord,
      oldRecordCharge,
      newRecordCharge,
      recordCreatedBy,
      startDateEdit,
    } = this.state;
    const { dispatch } = this.props;
    let payload__ = {
      PscChargePendingId: pendingRecord,
      OldCharges: oldRecordCharge,
      NewCharges: newRecordCharge,
      CreatedBy: recordCreatedBy,
      StartDate: appHelpers.formatDateSpecific(startDateEdit, "YYYY-MM-DD"),
    };
    console.log("azee",payload__)

    dispatch(alertActions.startRequest());
    commonService
      .editPsc(payload__)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({
            errorMessage: res.response,
            editErrorComponent: true,
          });
        } else if (res.status === appConstants.SUCCESS_RESPONSE) {
          dispatch(alertActions.notify(res.response));
          this.getAllPsc();
          this.getAllUnprocessedPendingPsc();
          this.getCurrentPsc();
          this.setState({ open: false, editErrorComponent: false });
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.response));
      });
    dispatch(alertActions.clear());
  };

  //Approve/Decline Psc Charge
  handleApprove = (status, id) => {
    this.setState({
      pscPendingId: id,
      status: status,
      openComment: true,
    });
    status === 0 && this.setState({ reason: "Decline" });
    status === 1 && this.setState({ reason: "Approval" });
  };
  //Comment Modal
  openSubmitComment = () => {
    const { user, dispatch } = this.props;
    const { pscPendingId, status, comment } = this.state;
    let payload = {
      PscChargePendingId: pscPendingId,
      ApprovedBy: user.userId,
      Status: status,
      Comment: comment,
    };
    dispatch(alertActions.startRequest());
    commonService
      .approvePsc(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          status === 0 &&
            dispatch(alertActions.notify("PSC Charge Declined Successfully"));
          status === 1 &&
            dispatch(alertActions.notify("PSC Charge Approved Successfully"));
          this.getAllPsc();
          this.getAllUnprocessedPendingPsc();
          this.getCurrentPsc();
          this.setState({
            openApprove: false,
            openComment: false,
            comment: "",
          });
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ errorMessage: res.response });
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.response));
      });
    dispatch(alertActions.clear());
  };

  filterUsers = (userId) => {
    const { users } = this.state;
    if (users) {
      let userName = users.find((u) => u.Id === userId);
      if (userName) {
        return `${userName.FirstName} ${userName.LastName}`;
      } else {
        return "Unknown User"; //`Unknown User`;
      }
    }
  };

  render() {
    const { fullScreen, requesting } = this.props;
    const {
      pageRequesting,
      airlines,
      name,
      formError,
      currentPagePending,
      currentPage,
      error,
      editErrorComponent,
      pendingPscData,
      errorComponent,
      errorMessage,
      currentPsc,
      startDateNew,
      openModal,
      pscData,
      reason,
      comment,
      startDateEdit,
    } = this.state;

    if (pageRequesting) return <CircularProgress />;
    return (
      <GridContainer>
        <SettingsPanel
          errorComponent={errorComponent}
          formError={formError}
          error={error}
          errorMessage={errorMessage}
          openModal={openModal}
          handleChange={(event) => this.handleChange(event)}
          handlePsc={this.handlePsc}
          currentPsc={currentPsc}
          startDateNew={startDateNew}
          airlines={airlines}
          airline={name}
          selectChange={this.handleSelectChange("airlines")}
          handleDateChange={this.handleDateChange}
          handleClose={this.handleClose}
          handlePscSave={this.handlePscSave}
          disabled={requesting}
        />
        <Tabs
          headerColor="success"
          tabs={[
            {
              tabName: "All PSC Settings",
              tabIcon: Airline,
              tabContent: (
                <GridItem xs={12} sm={12} md={12}>
                  <ApprovedTable
                    records={pscData}
                    fetchRecords={this.getAllPsc}
                    classes={this.props.classes}
                    totalCounts={this.state.TotalCount}
                    filterUsers={this.filterUsers}
                    currentPage={currentPage}
                    pageSize={this.state.PageCount}
                    user={this.props.user}
                  />
                </GridItem>
              ),
            },
            {
              tabName: "Pending Settings",
              tabIcon: Seat,
              tabContent: (
                <GridItem xs={12} sm={12} md={12}>
                  <AllPscTable
                    handleApprove={this.handleApprove}
                    records={pendingPscData}
                    fetchRecords={this.getAllUnprocessedPendingPsc}
                    handleEdit={this.handleEdit}
                    handleApproveThreshold={this.openApprove}
                    classes={this.props.classes}
                    totalCounts={this.state.totalCountPending}
                    filterUsers={this.filterUsers}
                    currentPage={currentPagePending}
                    pageSize={this.state.PageCount}
                    user={this.props.user}
                  />
                </GridItem>
              ),
            },
          ]}
        />

        {/*// Edit Modal*/}
        <Dialog
          fullScreen={fullScreen}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            style={{ backgroundColor: "#66bb6a" }}
          >
            <span style={{ color: "white", textTransform: "uppercase" }}>
              Edit PS Charge
            </span>
          </DialogTitle>
          <DialogContent>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  disabled
                  required
                  labelText="Old Charge(&#8358;)"
                  id="oldRecordCharge"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    disabled: true,
                    value: this.state.oldRecordCharge,
                    name: "oldRecordCharge",
                    type: "number",
                    onChange: this.handleChange,
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="New Charge(&#8358;)"
                  id="newRecordCharge"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    required: true,
                    value: this.state.newRecordCharge,
                    name: "newRecordCharge",
                    type: "number",
                    onChange: this.handleChange,
                  }}
                />
                {editErrorComponent && (
                  <div style={{ color: "red", fontSize: "13px" }}>
                    {errorMessage}
                  </div>
                )}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <InlineDatePicker
                    Date={startDateEdit}
                    handleDateChange={(date) =>
                      this.handleDateChange(date, "startDateEdit")
                    }
                    label="Start Date"
                    minDate={Date()}
                  />
                </FormControl>
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="danger">
              Cancel
            </Button>
            <Button onClick={this.handleEditPsc} color="success" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/*//Comment Modal*/}
        <Dialog
          fullScreen={fullScreen}
          open={this.state.openComment}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            style={{ backgroundColor: "#66bb6a" }}
          >
            <span style={{ color: "white", textTransform: "uppercase" }}>
              Reason for {reason}
            </span>
          </DialogTitle>
          <DialogContent>
            <GridContainer>
              <Grid item md={12} sm={12}>
                <TextField
                  style={{
                    width: "100%",
                    minWidth: "300px",
                  }}
                  // disabled = {disabled}
                  // disabled={disabled}
                  multiline
                  rowsMax="10"
                  id="email"
                  label="Reason"
                  name="comment"
                  value={comment}
                  onChange={this.handleChange}
                  margin="normal"
                  variant="outlined"
                />
                <div
                  style={{
                    color: "red",
                    fontSize: "12px",
                  }}
                >
                  *State your reason
                </div>
                {/*<span>*/}
                {/*<Button onClick={this.handleActiveInput} color="success" autoFocus>*/}
                {/*Edit*/}
                {/*</Button>*/}
                {/*</span>*/}
              </Grid>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.openSubmitComment} color="primary" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </GridContainer>
    );
  }
}

PscSettingsTable.defaultProps = {
  tableHeaderColor: "gray",
};

PscSettingsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};
const mapStatesToProps = (state) => {
  const { modal, alert, airlines, progress, user, users, requesting } = state;
  return {
    modal,
    alert,
    airlines,
    progress,
    user,
    users,
    requesting,
  };
};

export default connect(mapStatesToProps)(withStyles(styles)(PscSettingsTable));



// WEBPACK FOOTER //
// ./src/views/PscSettings/Index.jsx